import { render, staticRenderFns } from "./Mill-static2.vue?vue&type=template&id=79ce2a40&"
import script from "./Mill-static2.vue?vue&type=script&lang=js&"
export * from "./Mill-static2.vue?vue&type=script&lang=js&"
import style0 from "./Mill-static2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports